<template>
  <div>
    <div class="row">
      <div
        class="col-md-6 col-xl-3"
        v-for="stats in statsCards"
        :key="stats.title"
      >
        <stats-card>
          <div
            class="icon-big text-center"
            :class="`icon-${stats.type}`"
            slot="header"
          >
            <i :class="stats.icon"></i>
          </div>
          <div class="numbers" slot="content">
            <p>{{ stats.title }}</p>
            {{ stats.value }}
          </div>
          <div class="stats" slot="footer">
            <i :class="stats.footerIcon"></i> {{ stats.footerText }}
          </div>
        </stats-card>
      </div>
    </div>
    <div class="d-flex align-items-end flex-wrap mb-3" style="gap: 1rem">
      <div class="col-auto p-0">
        <select
          class="form-control"
          v-model="selectedValue"
          placeholder="Select a search parameter"
        >
          <option value="">Select a search parameter</option>
          <option value="reference">Reference</option>
          <option value="accountNumber">Account Number</option>
          <option value="sessionId">Session ID</option>
          <option value="walletId">Wallet ID</option>
        </select>
      </div>
      <div class="col-auto p-0" v-if="selectedValue === 'reference'">
        <div class="input-group m-0">
          <input
            id="inlineFormInputGroup"
            class="form-control"
            v-model="reference"
            type="text"
            placeholder="Enter Reference"
          />
        </div>
      </div>
      <div class="col-auto p-0" v-if="selectedValue === 'accountNumber'">
        <div class="input-group m-0">
          <input
            id="inlineFormInputGroup"
            class="form-control"
            v-model="accountNumber"
            type="text"
            placeholder="Enter Account Number"
          />
        </div>
      </div>
      <div class="col-auto p-0" v-if="selectedValue === 'sessionId'">
        <div class="input-group m-0">
          <input
            id="inlineFormInputGroup"
            class="form-control"
            v-model="sessionId"
            type="text"
            placeholder="Enter Session ID"
          />
        </div>
      </div>
      <div class="col-auto p-0" v-if="selectedValue === 'walletId'">
        <div class="input-group m-0">
          <input
            id="inlineFormInputGroup"
            class="form-control"
            v-model="walletId"
            type="text"
            placeholder="Enter Wallet ID"
          />
        </div>
      </div>
      <div class="col-auto p-0">
        <label>Start Date</label>
        <div class="input-group m-0">
          <input
            type="date"
            class="form-control"
            id="inlineFormInputGroup"
            placeholder="Start Date"
            v-model="startDate"
          />
        </div>
      </div>
      <div class="col-auto p-0">
        <label>End Date</label>
        <div class="input-group m-0">
          <input
            type="date"
            class="form-control"
            id="inlineFormInputGroup"
            placeholder="End Date"
            v-model="endDate"
          />
        </div>
      </div>
      <div class="col-auto p-0">
        <button
          type="submit"
          class="btn btn-primary"
          @click="refresh('filter')"
        >
          Filter
        </button>
      </div>
      <div class="col-auto p-0">
        <button
          type="submit"
          class="btn btn-primary"
          @click="downloadFilteredTransactions"
          :disabled="loading"
        >
          <span
            v-if="loading"
            class="spinner-grow spinner-grow-sm"
            role="status"
            aria-hidden="true"
          ></span>
          Download
        </button>
      </div>

      <div class="col-auto p-0">
        <button class="btn btn-info" @click="refresh('refresh')">
          Refresh
        </button>
      </div>
    </div>
    <div class="spinner-grow" role="status" v-if="loading === true"></div>
    <div class="alert alert-danger" role="alert" v-if="error === true">
      {{ errorMsg }}
    </div>

    <div class="col-12">
      <card class="card-plain">
        <div class="table-full-width table-responsive">
          <table class="table">
            <thead class="tms-dark">
              <tr>
                <th scope="col" class="text-center">S/N</th>
                <th scope="col" class="text-center">Amount</th>
                <th scope="col" class="text-center">Account Number</th>
                <th scope="col" class="text-center">Wallet ID</th>
                <th scope="col" class="text-center">Sender's Account Name</th>
                <th scope="col" class="text-center">Sender's Account Number</th>
                <th scope="col" class="text-center">Bank</th>
                <th scope="col" class="text-center">Narration</th>
                <th scope="col" class="text-center">Reference</th>
                <th scope="col" class="text-center">Session ID</th>
                <th scope="col" class="text-center">Credit Status</th>
                <th scope="col" class="text-center">Date, Time</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="transactions.length === 0">
                <td colspan="12" class="text-center">No data found</td>
              </tr>
              <tr
                v-for="(transaction, index) in transactions"
                :key="transaction._id"
              >
                <th class="text-center">
                  {{ limit * (page - 1) + (index + 1) }}
                </th>
                <td class="text-center">
                  {{
                    `₦${format.format(
                      parseFloat(transaction.amount).toFixed(2),
                    )}`
                  }}
                </td>
                <td class="text-center">{{ transaction.accountNumber }}</td>
                <td class="text-center">
                  {{ transaction.walletId }}
                </td>
                <td class="text-center">
                  {{ transaction.originatorAccountName }}
                </td>
                <td class="text-center">
                  {{ transaction.originatorAccountNumber }}
                </td>
                <td class="text-center">
                  {{ transaction.originatorBank }}
                </td>
                <td class="text-center">
                  {{ transaction.originatorNarration }}
                </td>
                <td class="text-center">
                  {{ transaction.reference }}
                </td>
                <td class="text-center">
                  {{ transaction.sessionId }}
                </td>
                <td class="text-center">
                  <button :class="getCreditStatusClass(transaction)">
                    {{ transaction.creditStatus }}
                  </button>
                </td>
                <td class="text-center">
                  {{
                    moment
                      .utc(transaction.createdAt)
                      .format("Y-M-D, h:mm:ss a")
                  }},
                  <!-- {{
                    moment
                      .utc(transaction.createdAt)
                      .format("YYYY-MM-DD, hh:mm:ss A") removed utc to display in local time
                  }} -->
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </card>
    </div>

    <div class="pagination" style="justify-content: space-between; width: 100%">
      <div
        class="to-flex"
        style="display: flex; align-items: center; gap: 10px"
      >
        <button
          class="btn"
          :disabled="hasPrevPage === false"
          @click="refresh('previous')"
        >
          Previous
        </button>

        <span>Page {{ currentPage }} of {{ totalPages }}</span>

        <button class="btn" :disabled="!hasNextPage" @click="refresh('next')">
          Next
        </button>
      </div>

      <div class="p-2">
        <div class="btn">Total Records: {{ totalDocs }}</div>
      </div>
    </div>

    <!-- <div class="mt-2 d-flex justify-content-start align-items-center">
      <div class="p-2" v-if="hasPrevPage === true">
        <button
          type="submit"
          class="btn btn-primary mb-2 mt-4"
          @click="refresh('previous')"
        >
          Previous Page
        </button>
      </div>
      <div>Page {{ currentPage }} of {{ totalPages }}</div>
      <div class="p-2" v-if="hasNextPage === true">
        <button
          type="submit"
          class="btn btn-primary mb-2 mt-4"
          @click="refresh('next')"
        >
          Next Page
        </button>
      </div>
    </div>
    <div class="mt-2 d-flex justify-content-end align-items-center">
      <div class="p-2">
        <div class="btn">Total Records: {{ totalDocs }}</div>
      </div>
    </div> -->
  </div>
</template>

<script>
import axios from "../store/axios";
import moment from "moment";
import { mapActions, mapState } from "vuex";
import fileDownload from "js-file-download";
import { convertArrayToCSV } from "convert-array-to-csv";
import { StatsCard } from "@/components/index";

export default {
  components: {
    StatsCard,
  },
  data() {
    return {
      statsCards: [
        {
          type: "info",
          icon: "ti-save",
          title: "Total Transactions",
          value: "₦0",
          footerIcon: "ti-reload",
          footerText: `0`,
        },
      ],
      currentPage: 1,
      error: false,
      loading: false,
      errorMsg: "",
      moment,
      format: new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
      page: 1,
      limit: 50,
      totalPages: 0,
      hasPrevPage: false,
      hasNextPage: true,
      prevPage: null,
      nextPage: null,
      totalDocs: 0,
      pageNumbers: [],
      transactions: [],
      selectedValue: "",
      reference: "",
      accountNumber: "",
      sessionId: "",
      walletId: "",
      creditStatus: false,
      startDate: moment().format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
    };
  },
  computed: {
    ...mapState(["auth"]),
  },

  methods: {
    ...mapActions(["setNotification"]),

    async downloadFilteredTransactions() {
      this.loading = true;
      try {
        let allTransactions = [];
        let currentPage = 1;
        const limit = 50;
        let totalPages = 1;

        while (currentPage <= totalPages) {
          const response = await axios.get(
            `${process.env.VUE_APP_API_URL}/transactions/webhook`,
            {
              params: {
                page: currentPage,
                limit: limit,
                reference: this.reference,
                accountNumber: this.accountNumber,
                sessionId: this.sessionId,
                walletId: this.walletId,
                startDate: this.startDate,
                endDate: this.endDate,
              },
            },
          );

          const { docs, totalPages: total } = response.data.transactions;
          totalPages = total;
          allTransactions = allTransactions.concat(docs);
          currentPage++;
        }

        const csvData = convertArrayToCSV(allTransactions);
        fileDownload(csvData, "pay_with_transfer_transactions.csv");
      } catch (error) {
        this.error = true;
        this.errorMsg = "Unable to Download All Transactions";
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    async refresh(mode) {
      try {
        this.loading = true;

        if (mode === "filter" || mode === "refresh") {
          this.page = 1;
          this.currentPage = 1;
        }

        if (mode === "refresh") {
          this.startDate = moment().format("YYYY-MM-DD");
          this.endDate = moment().format("YYYY-MM-DD");
        }

        let payload = {
          page: this.page,
          limit: this.limit,
          reference: this.reference,
          accountNumber: this.accountNumber,
          sessionId: this.sessionId,
          walletId: this.walletId,
          startDate: this.startDate,
          endDate: this.endDate,
        };

        switch (mode) {
          case "next":
            payload = { ...payload, page: this.nextPage };
            this.currentPage = this.nextPage;
            break;
          case "previous":
            payload = { ...payload, page: this.prevPage };
            this.currentPage = this.prevPage;
            break;
        }
        const res = await axios.get(
          `${process.env.VUE_APP_API_URL}/transactions/webhook`,
          { params: payload },
        );

        const {
          docs,
          hasNextPage,
          hasPrevPage,
          totalPages,
          prevPage,
          nextPage,
          totalDocs,
          page,
        } = res.data.transactions;
        this.transactions = docs;
        this.hasPrevPage = hasPrevPage;
        this.hasNextPage = hasNextPage;
        this.totalPages = totalPages;
        this.prevPage = prevPage;
        this.nextPage = nextPage;
        this.totalDocs = totalDocs;
        this.page = page;
        const { total } = res.data.summary;
        this.statsCards[0].value = `₦${this.format.format(total.toFixed(2))}`;
        this.statsCards[0].footerText = this.totalDocs;
      } catch (error) {
        this.error = true;
        this.errorMsg = "Unable to Fetch Transactions";
      }
      this.loading = false;
    },

    getCreditStatusClass(transaction) {
      return {
        "text-center": true,
        "type-btn": true,
        true: transaction.creditStatus === true,
        false: transaction.creditStatus === false,
      };
    },
  },

  async mounted() {
    try {
      this.loading = true;
      const res = await axios.get(
        `${process.env.VUE_APP_API_URL}/transactions/webhook`,
        {
          params: {
            page: this.page,
            startDate: moment().format("YYYY-MM-DD"),
            endDate: moment().format("YYYY-MM-DD"),
          },
        },
      );
      const {
        docs,
        hasNextPage,
        hasPrevPage,
        totalPages,
        prevPage,
        nextPage,
        totalDocs,
        page,
      } = res.data.transactions;
      this.transactions = docs;
      this.hasPrevPage = hasPrevPage;
      this.hasNextPage = hasNextPage;
      this.totalPages = totalPages;
      this.prevPage = prevPage;
      this.nextPage = nextPage;
      this.totalDocs = totalDocs;
      this.page = page;
      const { total } = res.data.summary;
      this.statsCards[0].value = `₦${this.format.format(total.toFixed(2))}`;
      this.statsCards[0].footerText = this.totalDocs;
    } catch (error) {
      if (error.response && error.response.data) {
        const { message } = error.response.data;
        this.setNotification({ type: "danger", message });
      } else {
        this.setNotification({
          type: "danger",
          message: "Unable to Fetch Transactions",
        });
      }
    }
    this.loading = false;
  },
};
</script>

<style scoped>
th {
  font-size: 12px !important;
  font-weight: 500 !important;
}

tbody {
  background: #fff !important;
}

.tms-dark {
  background-color: #333f48;
  color: #fff;
}

button {
  padding: 0.2rem 10px !important;
}

.type-btn {
  padding: 10px 15px !important;
  border: none;
  border-radius: 5px;
}

.true {
  background-color: rgb(11, 155, 11);
  color: #fff;
  font-weight: bolder;
}

.false {
  background-color: rgb(217, 16, 16);
  color: #fff;
  font-weight: bolder;
}
</style>
